<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <!-- <breadcrumb class="breadcrumb-container" /> -->

    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <el-select size="small" style="width: 260px" v-model="value" placeholder="请选择" @change="changeAccount">
            <el-option v-for="item in options" :key="item.id" :label="`${roleMap[item.role]} ${item.real_name} ${item.account}`" :value="item.id"> </el-option>
          </el-select>

          <el-button style="margin-left: 60px" round size="small" @click="logout" icon="el-icon-switch-button">退出</el-button>
        </div>
      </el-dropdown>
    </div>

    <!-- <el-button
      type="warning"
      size="small"
      style="margin: 10px 20px;float: right;"
      :loading="importantNotifyLoading"
      @click="getImportantNotify"
    >检查未处理</el-button> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { getImportantNotify } from "@/api/getData";

export default {
  data() {
    return {
      admin: {},
      avatarSrc: require("../../assets/img/tupian.jpg"),
      importantNotifyLoading: false,
      options: [],
      optionsMap: {},
      value: "",
      roleMap: {
        SuperAdmin: "超级管理员",
        Super: "管理员",
        Buyer: "采购",
        Keeper: "库管",
        Anchor: "主播",
        Operator: "运营",
        Distribution: "经销",
        Inventory: "盘点",
        Logistics: "后勤",
        External: "外部",
      },
    };
  },
  async beforeCreate() {
    if (!this.$admin || !this.$admin.id) {
      const adminObjStr = await localStorage.getItem("adminObjStr");
      if (!adminObjStr || adminObjStr === "null") return;
      this.$admin = JSON.parse(adminObjStr);
    }

    let userListStr = await localStorage.getItem("userList");
    this.options = JSON.parse(userListStr);
    this.options.forEach((e) => {
      this.optionsMap[e.id] = e;
    });

    this.value = this.$admin.id;
  },

  async created() {
    this.admin = this.$admin;
  },

  components: {
    // Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"]),
  },
  methods: {
    async changeAccount() {
      await localStorage.setItem("accessToken", ""); // 初始化token
      await localStorage.setItem("accessToken", this.optionsMap[this.value].token);
      await localStorage.setItem("adminObjStr", JSON.stringify(this.optionsMap[this.value]));
      await localStorage.setItem("adminRoles", this.optionsMap[this.value].role);

      this.$admin = this.optionsMap[this.value];

      this.admin = this.optionsMap[this.value];

      await this.$oss.getOSSClient(this);

      await this.$router.replace({ path: "/" });
      // await location.reload();
    },

    async getImportantNotify() {
      this.importantNotifyLoading = true;
      const res = await getImportantNotify();
      this.importantNotifyLoading = false;
      if (res.code !== 0) return;
      this.$emit("important-notify", res.data);
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      localStorage.removeItem("accessToken"); //token
      localStorage.removeItem("adminObjStr"); //管理员对象数据
      localStorage.removeItem("adminRoles");
      this.$router.replace({ path: "/login" });
      location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
